import { AuthService } from 'src/app/services/auth/auth.service';
import { CartService } from './../services/cart/cart.service';
import { AlertController, NavController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SingleSalonGuard implements CanActivate {
  constructor(
    private alertController: AlertController,
    private navController: NavController,
    private cartService: CartService,
    private auth: AuthService,
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Promise<boolean>(async (resolve, reject) => {
      const cart = this.cartService.getCart();

      if (! localStorage.getItem('current-salon') || cart.length === 0) {
        resolve(true);
        return;
      }
      
      const current_salon = JSON.parse(localStorage.getItem('current-salon'));
      const next_salon_slug = next.params['slug'];
      let comparison;

      if (typeof next_salon_slug === 'undefined') {
        const next_salon = JSON.parse(localStorage.getItem('next-salon'));
        
        comparison = (current_salon.id !== next_salon.id);
      } else {
        comparison = (current_salon.slug !== next_salon_slug);
      }
      
      if (comparison === true) {
        const alert = await this.alertController.create({
          header: 'Clear existing order?',
          message: 'You have already started an order with ' + current_salon.name + '. Do you want to clear this order and start a new one?',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                alert.dismiss().then(() => { 
                  resolve(false); 
                });

                return false;
              }
            },
            {
              text: 'Clear and Proceed',
              role: 'proceed',
              handler: () => {
                this.auth.isLoggedIn().then((isLoggedIn: boolean) => {
                  if (isLoggedIn === true) {
                    this.cartService.clearCartExternal();
                  }

                  this.cartService.clearCart();
                  // localStorage.removeItem('current-salon');
                  localStorage.removeItem('in_use_voucher');
                  
                  alert.dismiss();
                });
                
                resolve(true);
                return true;
              }
            }
          ]
        });

        await alert.present();
      } else {
        resolve(true);
      }
    })
  }
}
